import { AxiosInstance } from 'axios';
import { ContactEndpoints, GetContactsRequest, GetContactsResponse } from './ContactServices.types';

export class ContactServices implements ContactEndpoints {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  getContacts(request: GetContactsRequest) {
    return this.instance.get<GetContactsResponse>('/contacts', {
      params: request.queryParams,
    });
  }
}
